module.exports = __webpack_public_path__ + "assets/img/29_33_big.0eaa60a4.jpg";